import { Card, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { dateFormat } from '../../supervisions/utils/dateFormat';

const { Text, Title } = Typography;

export const ReviewsCards = ({ review, t, user }) => {
  const receiverName = review?.receiver?.id?.map((item) => ({
    first_name: item?.first_name,
    last_name: item?.last_name
  }));

  const title = t('supervisions.users_shows.supervision_date', {
    reference: review?.supervision?.reference,
    ...dateFormat(
      review?.supervision?.main_informations?.start_date,
      review?.supervision?.main_informations?.end_date,
      user?.role
    )
  });

  return (
    <Col xs={24} lg={12} xl={8}>
      <Card
        title={title}
        key={review._id}
        styles={{ body: { paddingTop: 12 } }}
      >
        <Title level={5}>
          {t('owners.users_shows.reviews.given_to', receiverName?.[0] ?? {})}
        </Title>
        <Text>{review?.comment_or_suggestion}</Text>
      </Card>
    </Col>
  );
};

ReviewsCards.propTypes = {
  review: PropTypes.shape({
    _id: PropTypes.string,
    receiver: PropTypes.shape({
      id: PropTypes.arrayOf(
        PropTypes.shape({
          first_name: PropTypes.string,
          last_name: PropTypes.string
        })
      )
    }),
    supervision: PropTypes.shape({
      reference: PropTypes.string,
      main_informations: PropTypes.shape({
        start_date: PropTypes.string,
        end_date: PropTypes.string
      })
    }),
    comment_or_suggestion: PropTypes.string
  }).isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    role: PropTypes.string
  }).isRequired
};
